import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCollaborators } from "./../../redux/contactApi";
import Collaborator from "./Collaborator.js";
import ModalAddCollaboratorForm from "./ModalAddCollaboratorForm";
import {
  updateRightSideReducerState,
} from "./../../redux/contactAction.js";
import CustomAccordion, {
  CustomAccordionBody,
  CustomAccordionHeader,
} from "../../components/Accordion/CustomAccordion.js";
import { Box } from "@material-ui/core";
import AddIcon from '@material-ui/icons/Add';
import { icons } from "../../icons.js";
import ModalAddCollaboratorFormV2 from "./ModalAddCollaboratorFormV2.js";

const Collaborators = (props) => {
  const [show, setShow] = useState(false);
  const [collaborators, setCollaborators] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [expand, setExpand] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    loadCollaboratorList();
  }, [props.contact_id]);

  const changeVisibility = () => {
    setShow(!show);
  };

  const modalToggle = () => {
    setShowModal(!showModal);
  };

  const expandAccordionToggle = () => {
    setExpand(!expand);
  };

  const loadCollaboratorList = () => {
    getCollaborators({  contact_id: props.contact_id }).then((res) => {
      setCollaborators(res.data);
      dispatch(updateRightSideReducerState({ collaborators: res.data }));
    });
  };

  const reloadCollaborators = () => {
    loadCollaboratorList();
    setShowModal(false);
    setShow(true);
  };

  const callBack = async () => {
    reloadCollaborators();
  };

  let count = collaborators.length;

  let renderCollaborator = collaborators.length > 0 ? (
      collaborators.map((data, index) => (
          <Collaborator
              reloadCollaborators={reloadCollaborators}
              contact_id={props.contact_id}
              key={index}
              data={data}
          />
      ))
  ) : (
      <div style={{display:"flex",justifyContent:"center"}}>
        {/* <p>None Assigned</p> */}
      </div>
  );

  return (
      <Box sx={{marginTop:'10px'}}>
        <CustomAccordion
            expand={expand}
            className="g-contact-details-collapsible"
        >
          <CustomAccordionHeader
              onClick={expandAccordionToggle}
              className={`${expand ? "g-collapsible-header-for-deal" : "g-collapsible-header"}  ${expand ? "expand" : ""}`}
          >
          <span className={`${expand ? "g-header-title-for-deal" : "g-header-title"}`}>
            <span className="material-icons" style={{ marginTop: "-12px" }}>
              <svg
                  width="23"
                  height="14"
                  viewBox="0 0 16 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                  <path
                      d="M15.5 10.9837H6.5C6.36739 10.9837 6.24021 11.0363 6.14645 11.1299C6.05268 11.2235 6 11.3505 6 11.4829V12.4814C6 12.6138 6.05268 12.7408 6.14645 12.8344C6.24021 12.928 6.36739 12.9806 6.5 12.9806H15.5C15.6326 12.9806 15.7598 12.928 15.8536 12.8344C15.9473 12.7408 16 12.6138 16 12.4814V11.4829C16 11.3505 15.9473 11.2235 15.8536 11.1299C15.7598 11.0363 15.6326 10.9837 15.5 10.9837ZM15.5 0.999023H6.5C6.36739 0.999023 6.24021 1.05162 6.14645 1.14525C6.05268 1.23887 6 1.36585 6 1.49826V2.49672C6 2.62913 6.05268 2.75611 6.14645 2.84973C6.24021 2.94336 6.36739 2.99596 6.5 2.99596H15.5C15.6326 2.99596 15.7598 2.94336 15.8536 2.84973C15.9473 2.75611 16 2.62913 16 2.49672V1.49826C16 1.36585 15.9473 1.23887 15.8536 1.14525C15.7598 1.05162 15.6326 0.999023 15.5 0.999023ZM15.5 5.99135H6.5C6.36739 5.99135 6.24021 6.04395 6.14645 6.13757C6.05268 6.2312 6 6.35818 6 6.49059V7.48905C6 7.62146 6.05268 7.74844 6.14645 7.84206C6.24021 7.93569 6.36739 7.98828 6.5 7.98828H15.5C15.6326 7.98828 15.7598 7.93569 15.8536 7.84206C15.9473 7.74844 16 7.62146 16 7.48905V6.49059C16 6.35818 15.9473 6.2312 15.8536 6.13757C15.7598 6.04395 15.6326 5.99135 15.5 5.99135Z"
                      fill={expand?"#fff":"#181f48"}
                  ></path>
                  <path
                      d="M4.3628 0.109638C4.32796 0.0747319 4.28656 0.0470356 4.24098 0.0281376C4.1954 0.00923965 4.14653 -0.000488281 4.09717 -0.000488281C4.04781 -0.000488281 3.99895 0.00923965 3.95336 0.0281376C3.90778 0.0470356 3.86638 0.0747319 3.83155 0.109638L1.84155 2.08504L1.13217 1.39485C1.09733 1.35995 1.05593 1.33225 1.01035 1.31335C0.964771 1.29445 0.915901 1.28473 0.866546 1.28473C0.81719 1.28473 0.768321 1.29445 0.722739 1.31335C0.677157 1.33225 0.635759 1.35995 0.600921 1.39485L0.110296 1.88535C0.0753357 1.92013 0.0475969 1.96147 0.0286699 2.00698C0.00974286 2.05249 0 2.10129 0 2.15057C0 2.19985 0.00974286 2.24864 0.0286699 2.29415C0.0475969 2.33966 0.0753357 2.381 0.110296 2.41578L1.59748 3.89476C1.67172 3.96522 1.77022 4.00451 1.87264 4.00451C1.97506 4.00451 2.07356 3.96522 2.1478 3.89476L2.63498 3.40739L4.89123 1.15491C4.96153 1.08466 5.00125 0.98957 5.00178 0.890267C5.00231 0.790964 4.96359 0.695459 4.89405 0.624473L4.3628 0.109638ZM4.3628 5.0767C4.32796 5.04179 4.28656 5.01409 4.24098 4.9952C4.1954 4.9763 4.14653 4.96657 4.09717 4.96657C4.04781 4.96657 3.99895 4.9763 3.95336 4.9952C3.90778 5.01409 3.86638 5.04179 3.83155 5.0767L1.84155 7.06489L1.13217 6.37533C1.09733 6.34042 1.05593 6.31273 1.01035 6.29383C0.964771 6.27493 0.915901 6.2652 0.866546 6.2652C0.81719 6.2652 0.768321 6.27493 0.722739 6.29383C0.677157 6.31273 0.635759 6.34042 0.600921 6.37533L0.110296 6.86489C0.0753357 6.89967 0.0475969 6.94101 0.0286699 6.98652C0.00974286 7.03203 0 7.08083 0 7.13011C0 7.17939 0.00974286 7.22818 0.0286699 7.27369C0.0475969 7.31921 0.0753357 7.36054 0.110296 7.39532L1.59373 8.87742C1.66791 8.94786 1.76637 8.98713 1.86873 8.98713C1.9711 8.98713 2.06955 8.94786 2.14373 8.87742L2.63436 8.38786L4.89061 6.13445C4.96064 6.06469 5.00023 5.97013 5.00075 5.87137C5.00128 5.7726 4.9627 5.67763 4.89342 5.60713L4.3628 5.0767ZM1.99998 10.4843C1.17217 10.4843 0.481546 11.1552 0.481546 11.982C0.481546 12.8089 1.1728 13.4797 1.99998 13.4797C2.39781 13.4797 2.77934 13.3219 3.06064 13.0411C3.34195 12.7602 3.49998 12.3792 3.49998 11.982C3.49998 11.5848 3.34195 11.2039 3.06064 10.923C2.77934 10.6421 2.39781 10.4843 1.99998 10.4843Z"
                      fill={expand?"#fff":"#181f48"}
                  ></path>
                </svg>
            </span>{" "}
            Collaborators <span className="g-header-count" style={{color:'black'}}>{count}</span>
          </span>

            <div className="g-header-action-content">
            <span className="g-add-task-button" onClick={modalToggle} style={{background:'white',height:'26px',width:'26px',display:'flex',justifyContent:'center',alignItems:'center',borderRadius:'50%'}}>
            <AddIcon style={{fontSize:'14px',color: "var(--light_blue)"}}/>
            </span>
              <span className={`${expand?"g-custom-caret-for-deal":"g-custom-caret"}`}>{icons.caretIcon}</span>
            </div>
          </CustomAccordionHeader>
          <CustomAccordionBody
              className="g-collapsible-body"
              expand={expand}
          >
            <div style={{padding:'8px 2px'}}>{renderCollaborator}</div>
          </CustomAccordionBody>
        </CustomAccordion>
        {showModal && (
            <ModalAddCollaboratorFormV2
                contact_id={props.contact_id}
                selected={collaborators}
                title={"Add Collaborators"}
                isOpen={showModal}
                callBack={callBack}
                modalToggle={modalToggle}
                open={showModal}
                onClose={() => setShowModal(false)}
            />
        )}
      </Box>
  );
};

export default Collaborators;